import { closeModal } from "action/modal/closeModal";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { ReactNode } from "react";
import PAModal, { IPAModalHeader, MODAL_SIZE } from "../PAModal";
import styles from "./bottom-sheet.module.scss";

interface Props {
  size?: number;
  header?: IPAModalHeader;
  show?: boolean;
  view?: string;
  children: ReactNode
  headerUrl?: string;
  titleClass?: string;
  hasDropdown?: boolean;
  persistent?: boolean;
  contentClassName?: string;
  onHide?: () => void;
  modalBodyClassName?: string;
  dialogClass?: string;
  showHeader?: boolean;
  showTopRightCloseButton?: boolean;
  headerClass?: string;
  showWhite?: boolean;
}

function PAModalMultipleView(props: Props) {
  const {
    size = MODAL_SIZE.LARGE, header, show = false, children, view,
    headerUrl, contentClassName, hasDropdown = false, persistent = false,
    modalBodyClassName = "", dialogClass = "", showHeader = true,
    showTopRightCloseButton = false, headerClass = "", showWhite = false,
  } = props;

  const dispatch = useDispatch();

  let modalClasses = {};

  if (view === "fromBottom") {
    modalClasses = {
      modelBodyClassName: `${styles.bottom_sheet_body} ${modalBodyClassName}`,
      dialogClassName: `${styles.bottom_sheet_dialog} ${dialogClass}`,
      headerClassName: headerClass,
      contentClassName: `${styles.content_class} ${contentClassName}`,
      backdropClassName: styles.bottom_sheet_backdrop,
    };
  } else if (view === "fromRight") {
    modalClasses = {
      modelBodyClassName: `${styles.from_right_sidebar} ${modalBodyClassName}`,
      dialogClassName: styles.from_right_dialog,
      headerClassName: `${styles.modal_header} ${headerClass}`,
    };
  }

  return (
    <PAModal
      size={size}
      header={header}
      onHide={() => {
        if (!persistent) {
          dispatch(closeModal());
          if (props.onHide) {
            props.onHide();
          }
        }
      }}
      show={show}
      className={classnames({
        [styles.modal_dialog]: true,
        [styles.sideBar]: view === "fromRight",
      })}
      {...modalClasses}
      view={view}
      contentClassName={`${styles.content_class} ${contentClassName}`}
      backdropClassName={styles.backdrop_className}
      headerUrl={headerUrl}
      hasDropdown={hasDropdown}
      showHeader={showHeader}
      showTopRightCloseButton={showTopRightCloseButton}
      showWhite={showWhite}
    >

      {children}

    </PAModal>
  );
}

export default PAModalMultipleView;
